export default "__VITE_ASSET__B4kAFb3x__"